// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"02ac2773","787":"5a7293ce"}[chunkId] + ".chunk.js";
};